<template>
    <AuthenticatedLayout>

<!--        <ConfirmDialog></ConfirmDialog>-->
        <ConfirmPopup></ConfirmPopup>
        <Toast position="top-center" />

        <div v-if="$page.props.auth.user.is_demo">
            <DemoBotWarning :current-date="currentDate"/>
        </div>

        <div class="flex flex-row w-full align-items-center justify-content-between mb-4 mt-4">
            <div class="flex flex-row align-items-center">
                <div class="text-4xl mr-3">High-Low Level bot for {{pair.symbol}}</div>
                <div class="mr-4">
                    <a class="text-gray-400" :href="'https://ru.tradingview.com/chart/?symbol=BINANCE%3A'+pair.symbol" target="_blank"><i class="pi pi-external-link" style="font-size: 1.5rem"></i></a>
                </div>
                <div>
                    <div class="" @click="showPairsSelect = !showPairsSelect">
                        <Button v-if="!showPairsSelect" label="" icon="pi pi-chevron-down" iconPos="right" class="p-button-outlined p-button-lg"/>
                        <Button v-else label="" icon="pi pi-chevron-up" iconPos="right" class="p-button-outlined p-button-lg"/>
                    </div>
                </div>
            </div>
            <div class="flex flex-row align-items-center"> <!--justify-content-between-->
                <div class="text-gray-500 mr-4 flex flex-column">
                    <div>userbot #{{userBotId}}</div>
                    <div>pair #{{pair.id}}</div>
                </div>
                <div class="mr-4 flex flex-row align-items-center">
                    <div class="text-2xl mr-2">Работа:</div><InputSwitch v-model="isBotActive" ></InputSwitch>
                </div>
<!--                <div>-->
<!--                    <SelectButton v-model="selectedBotMode" :options="botModeItems" optionLabel="label" optionValue="value" />-->
<!--                </div>-->
            </div>

        </div>

        <div v-if="showPairsSelect" class="mb-4">
            <PairsTwoTableSelector :items="botPairMenuItems" :compact="true" :select="handleSelectPair"/>
        </div>

        <div class="mb-4">
            <Card v-if="true">
                <template #content>
                    <div class="flex flex-row align-items-center">
                        <div class="flex flex-row align-items-center">
                            <div class="text-xl mr-2">Лимит USDT для этого типа ботов:</div>
                            <div class="mr-2"><InputNumber v-model="availableUsdtByReasonForm" mode="decimal" class="w-10"/></div>
                            <div class="mr-4">
                                <Button type="button" label="Сохранить" @click="saveAvailableUsdtByReason" />
                            </div>
                            <div v-if="availableUsdtByReasonForm === null" class="text-gray-500">
                                Будет использоваться глобальный лимит USDT
                            </div>

                        </div>
                        <Divider layout="vertical" />
                        <div class="flex flex-row align-items-center">
                            <Link :href="'/hll/stats/'+pair.symbol" class="no-underline"><Button label="Статистика"/></Link>
                        </div>
                    </div>
                </template>
            </Card>

            <Card v-if="false">
                <template #content>
                    <div class="flex flex-row align-items-center justify-content-between">
                        <div class="flex flex-row align-items-center">
                            <div class="text-xl mr-4">Режим эмуляции!</div>
                            <div class="text-xl mr-2">Кошелёк режима эмуляции для этого бота:</div>
                            <div class="mr-2"><InputNumber v-model="availableUsdtForDryRunForm" mode="decimal" class="w-10"/></div>
                            <div class="mr-2">
                                <Button type="button" label="Сохранить" @click="saveAvailableUsdtForDryRun" />
                            </div>
                        </div>
                        <div class="flex flex-row align-items-center">

                        </div>
                    </div>
                </template>
            </Card>
        </div>

        <div class="mb-4 flex">

            <div class="mr-4">
                <Card>
                    <template #content>
<!--                        <CandlesWithDeals-->
<!--                            :candles="candles"-->
<!--                            :deals="[...closedDeals, ...openDeals]"-->
<!--                            :pair="pair.symbol"-->
<!--                            :width="1000"-->
<!--                            :timezone="0"-->
<!--                            :zeroPrice="currentPrice"-->

<!--                        />-->
                        <CandlesDealsHll
                            :candles="candles"
                            :deals="[...closedDeals, ...openDeals]"
                            :indicators="indicators"
                            :pair="pair.symbol"
                            :width="maxWidth"
                            :height="500"
                            :timezone="0"
                            :zeroPrice="currentPrice"
                        />
                    </template>
                </Card>
            </div>

            <div class="flex flex-column w-full">
                <Card>
                    <template #content>

                        <div class="flex flex-row">
                            <div class="text-lg">
                                <span v-if="slowtrendValue === 'up'" class="text-green-600 font-bold">Slowtrend: up</span>
                                <span v-if="slowtrendValue === 'side'" class="">Slowtrend: side</span>
                                <span v-if="slowtrendValue === 'down'" class="text-red-600 font-bold">Slowtrend: down</span>
                            </div>
                            <div class="ml-3">

                            </div>
                        </div>

                        <TabView :activeIndex.sync="activeTab" >
                            <TabPanel key="bot">
                                <template #header>
                                    <span>Бот</span>
                                </template>
                                <div class="flex flex-column">
                                    <HllBotSettings v-model="form.botSettings"></HllBotSettings>
                                </div>
                            </TabPanel>
                            <TabPanel key="slowtrend">
                                <template #header>
                                    <span>Slowtrend</span>
                                </template>
                                <div class="flex flex-column">
                                    <TrendIndicatorSettings v-model="form.slowtrendSettings"></TrendIndicatorSettings>
                                </div>
                            </TabPanel>
                            <TabPanel key="band">
                                <template #header>
                                    <span>Band</span>
                                </template>
                                <div class="flex flex-column">
                                    <BandIndicatorSettings v-model="form.bandSettings"></BandIndicatorSettings>
                                </div>
                            </TabPanel>
                            <TabPanel key="dontselllong">
                                <template #header>
                                    <span>DontSellLong</span>
                                </template>
                                <div class="flex flex-column">
                                    <DontSellLongSettings v-model="form.dontselllongSettings"></DontSellLongSettings>
                                </div>
                            </TabPanel>
                            <TabPanel key="middletrend">
                                <template #header>
                                    <span>Middletrend</span>
                                </template>
                                <div class="flex flex-column">
                                    <MiddletrendSettings v-model="form.middletrendSettings"></MiddletrendSettings>
                                </div>
                            </TabPanel>
                            <TabPanel key="hll">
                                <template #header>
                                    <span>Hll</span>
                                </template>
                                <div class="flex flex-column">
                                    <HllIndicatorSettings v-model="form.hllSettings"></HllIndicatorSettings>
                                </div>
                            </TabPanel>

                        </TabView>

                        <div class="mb-4">
                            <div class="flex flex-row align-items-center">
                                <InputSwitch v-model="autoTuning" @click="changeAutoTuning"></InputSwitch><div class="ml-2">Автоматическая настройка параметров</div>
                            </div>
                            <div class="text-sm text-gray-500" style="margin-left: 45px;" v-if="form.botSettings.autoTuning">Дата настройки параметров:
                                <span v-if="tunedAt">{{tunedAt}} UTC</span>
                                <span v-else>не проводилось</span>
                            </div>
                        </div>

                        <div class="mt-2 flex flex-row justify-content-between">
                            <div class="flex flex-row">
                                <SpinnerWrapper :loading="isSavingBot"><Button @click="saveBotSettings(botResultData.userBotId)">Сохранить</Button></SpinnerWrapper>
                                <Link :href="'/preview/hll/'+userBotId" class="ml-4 no-underline"><Button label="Настроить бота"/></Link>
                            </div>

                            <Button @click="resetBotSettings" class="p-button-danger p-button-outlined">Сбросить в дефолт</Button>
                        </div>


                    </template>
                </Card>
            </div>


        </div>

        <div class="flex">
            <div class="flex-1">
                <Card class="mb-4">
                    <template #title>
                        Открытые cделки {{pair.symbol}} ({{openDeals.length}}, примерно ${{sumUsdtInOpenDeals}})
                    </template>
                    <template #content>
                        <OpenDealsTable :deals="openDeals" :currentPrice="currentPrice"></OpenDealsTable>
                    </template>
                </Card>

                <Card>
                    <template #title>
                        Закрытые сделки {{pair.symbol}}
                    </template>
                    <template #content>
                        <ClosedDealsTable :deals="closedDeals"></ClosedDealsTable>
                    </template>
                </Card>

            </div>
            <div class="flex-1 ml-4">
                <Card>
                    <template #title>
                        Логи {{pair.symbol}}
                    </template>
                    <template #content>
                        <div v-if="logs.length > 0">
                            <LogsTable :logs="logs"></LogsTable>
                        </div>
                        <div v-else>
                            <p>Логи отсутствуют.</p>
                        </div>
                    </template>
                </Card>
            </div>
        </div>

    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import InputText from 'primevue/inputtext'
import Card from 'primevue/card'
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { Link } from '@inertiajs/vue2'
import helperMethods from '@/helpers'
import PairsHorisontalMenu from "@/Menu/PairsHorisontalMenu";
import CandlesWithDeals from "@/Charts/Candles.vue";
import Toast from 'primevue/toast';
import ProgressSpinner from 'primevue/progressspinner';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import SpinnerWrapper from "@/Components/SpinnerWrapper";
import InputNumber from 'primevue/inputnumber';
import ClosedDealsTable from "@/Tables/ClosedDealsTable";
import LogsTable from "@/Tables/LogsTable";
import OpenDealsTable from "@/Tables/OpenDealsTable";
import SplitButton from 'primevue/splitbutton';
import Dropdown from 'primevue/dropdown';
import SelectButton from 'primevue/selectbutton';
import InputSwitch from 'primevue/inputswitch';
import PairsTwoTableSelector from "@/Menu/PairsTwoTableSelector.vue";
import Divider from "primevue/divider";
import DemoBotWarning from "@/Components/DemoBotWarning.vue";
import InlineMessage from "primevue/inlinemessage";
import HllBotSettings from "@/Settings/HllBotSettings.vue";
import TrendIndicatorSettings from "@/Settings/TrendIndicatorSettings.vue";
import BandIndicatorSettings from "@/Settings/BandIndicatorSettings.vue";
import DontSellLongSettings from "@/Settings/DontSellLongSettings.vue";
import MiddletrendSettings from "@/Settings/MiddletrendSettings.vue";
import CandlesDealsHll from "@/Charts/CandlesDealsHll.vue";
import HllIndicatorSettings from "@/Settings/HllIndicatorSettings.vue";
import ConfirmDialog from "primevue/confirmdialog";
import ConfirmPopup from 'primevue/confirmpopup';

export default {
    props: {
        openDeals: Array,
        closedDeals: Array,
        logs: Array,
        availableUsd: String,
        pair: Object,
        marketState: Object,
        candles: Array,
        botResultData: Object,
        currentPrice: String,
        botJsonSettings: String,
        botSettingsProp: Object,
        availableUsdtByReason: Number,
        availableUsdtByBot: Number,
        botPairMenuItems: Array,
        userBotId: Number,
        currentDate: String,
        isPast: Boolean,
        slowtrendValue: String,
        tunedAt: String,

        botSettings: Object,
        slowtrendSettings: Object,
        bandSettings: Object,
        hllSettings: Object,
        dontselllongSettings: Object,
        middletrendSettings: Object,

        indicators: Array,

        flash: Object
    },
    components:{
        ConfirmPopup,
        ConfirmDialog,
        HllIndicatorSettings,
        CandlesDealsHll,
        MiddletrendSettings,
        DontSellLongSettings,
        BandIndicatorSettings,
        TrendIndicatorSettings,
        HllBotSettings,
        DemoBotWarning,
        PairsTwoTableSelector,
        OpenDealsTable,
        CandlesWithDeals,
        // Contenteditable,
        AuthenticatedLayout, DataTable, InputText, Button, Column, Card, Link, Toast, ProgressSpinner, TabView, TabPanel, SpinnerWrapper,
        InputNumber,
        ClosedDealsTable, LogsTable, SplitButton, Dropdown, SelectButton, InputSwitch, Divider, InlineMessage
    },
    data(){
        return {
            botModeItems: [
                {label: 'Эмуляция', value: "dry_run", command: () => {this.changeBotMode('dry_run')}},
                {label: 'Торговля', value: "trade", command: () => {this.changeBotMode('trade')}}
            ],
            selectedBotMode: null,
            isBotActive: null,

            form: {
                maxOpenDeals: this.botResultData.bot.maxOpenDeals,
                fullSettings: JSON.stringify(this.botSettingsProp, null, 4),
                botSettings: this.botSettings,
                slowtrendSettings: this.slowtrendSettings,
                bandSettings: this.bandSettings,
                hllSettings: this.hllSettings,
                dontselllongSettings: this.dontselllongSettings,
                middletrendSettings: this.middletrendSettings,
            }, // редактирование настроек бота
            isSavingBot: false,
            autoTuning: this.botResultData.bot.autoTuning,

            activeTab: 0,
            availableUsdtByReasonForm: null,
            availableUsdtByBotForm: null,
            availableUsdtForDryRun: null,

            showPairsSelect: false,
        }
    },
    mounted() {
        this.selectedBotMode = this.botResultData.dry_run ? 'dry_run' : 'trade';

        this.isBotActive = this.botResultData.activated_at !== null;
        // console.log("this.botResultData.activated_at", this.botResultData.activated_at);

        // настройки
        //this.form.fullSettings = JSON.stringify(this.botResultData.bot.settings, null, 4);

        //this.botForm.green_hll_width = this.botResultData.bot.zone_settings.green_hll_width;
        this.availableUsdtByReasonForm = this.availableUsdtByReason;
        this.availableUsdtByBotForm = this.availableUsdtByBot;
        this.availableUsdtForDryRunForm = this.availableUsdtForDryRun;

        this.refreshSettings();
    },
    watch:{
        flash(newFlash, oldFlash){
            //console.log("flash", oldFlash, newFlash);
            if(newFlash.success !== null){
                this.$toast.add({severity:'success', summary: 'Success', detail: newFlash.success, life: 3000});
            }
            if(newFlash.error !== null){
                this.$toast.add({severity:'error', summary: 'Error', detail: newFlash.error, life: 5000});
            }
        },
        selectedBotMode(newMode, oldMode){
            if(oldMode && newMode !== oldMode){
                // console.log("mode", oldMode, newMode);
                this.changeBotMode(newMode);
            }
        },
        isBotActive(newActive, oldActive){ // todo сделать на @changed эвенте компонента
            if(oldActive !== null && newActive !== oldActive){
                // console.log("active", oldActive, newActive);
                this.changeBotActive(newActive);
            }
        },
    },
    computed: {
        bot(){
            return this.botResultData.bot;
        },
        sumUsdtInOpenDeals(){
            return Math.round(this.openDeals.reduce((sum, deal) => {
                return sum + parseFloat(deal.value_amount_started);
            }, 0));
        },
        settingsInJson(){
            return JSON.stringify(this.botSettings,null,'\t');
        },
        maxWidth(){
            return window.innerWidth - 800;
        }
    },
    methods:{
        ...helperMethods,
        refreshSettings(){
            this.form.botSettings = this.botSettings;
            this.form.hllSettings = this.hllSettings;
            this.form.slowtrendSettings = this.slowtrendSettings;
            this.form.bandSettings = this.bandSettings;
            this.form.dontselllongSettings = this.dontselllongSettings;
            this.form.middletrendSettings = this.middletrendSettings;
            this.autoTuning =  this.botSettings.autoTuning
        },
        changeBotMode(mode){
            this.$inertia.post("/bot/change_mode",
                {id: this.botResultData.userBotId, mode: mode},
                {preserveScroll: true, only: ['botResultData'],
                    onBefore: () => confirm('Вы уверены, что хотите изменить режим работы бота? Незакрытые старые сделки, сделанные в режиме эмуляции будут удалены.'),
                    onSuccess: page => {
                        let message = mode === 'dry_run' ? "Бот переведён в режим эмуляции, торговля не будет производиться." : "Бот переведён в режим торговли! Все открытые сделки, сделанные в режиме эмуляции, удалены.";
                        this.$toast.add({severity:'success', summary: 'Success', detail: message, life: 5000});
                    }
                },
            );
        },
        changeBotActive(isActive){
            this.$inertia.post("/bot/change_active",
                {id: this.botResultData.userBotId, set_active: isActive,},
                {preserveScroll: true, only: ['botResultData'],
                    onSuccess: page => {
                    let message = isActive ? "Бот запущен" : "Бот остановлен";
                    this.$toast.add({severity:'success', summary: 'Success', detail: message, life: 3000});
                }
                }
            );
        },
        saveBotSettings(id){
            this.isSavingBot = true;
            axios.post('/bot/store_hll_settings/', {
                id: this.userBotId,
                botSettings: this.form.botSettings,
                hllIndicatorSettings: this.form.hllSettings,
                trendIndicatorSettings: this.form.slowtrendSettings,
                bandIndicatorSettings: this.form.bandSettings,
                dontselllongIndicatorSettings: this.form.dontselllongSettings,
                middletrendIndicatorSettings: this.form.middletrendSettings
            }).then(response => {
                this.isSavingBot = false;
                this.$toast.add({severity:'success', summary: 'Success', detail: 'Настройки бота сохранены.', life: 3000});
            }).catch(error => {
                this.isSavingBot = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Ошибка сохранения настроек бота: '+error.message, life: 5000});
            });

        },
        resetBotSettings(event){
            let id = this.userBotId;
            //console.log(event, id);
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Будут загружены и применены настройки по умолчанию. Продолжить ?',
                header: 'Подтверждение',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.$inertia.post('/bot/reset_hll_settings', {
                        id: id
                    },{
                        // only: ['botResultData', 'botJsonSettings'],
                        onSuccess: (page) => {
                           this.refreshSettings();
                        },
                        onError: (errors) => {
                            // console.log("error", errors);
                            this.$toast.add({severity:'error', summary: 'Error', detail: "Ошибка сброса настроек бота", life: 5000});
                        }
                    });
                },
                reject: () => {

                }
            });


        },
        saveAvailableUsdtByReason(){
            this.$inertia.post('/bot/store_wallet_for_group', {
                id: this.botResultData.userBotId,
                value: this.availableUsdtByReasonForm
            }, {
                preserveScroll: true,
                only: ['botResultData'],
            })
        },
        saveAvailableUsdtForDryRun(){
            this.$inertia.post('/bot/store_wallet_for_dryrun', {
                id: this.botResultData.userBotId,
                value: this.availableUsdtForDryRunForm
            }, {
                preserveScroll: true,
                only: ['botResultData'],
            })
        },
        handleSelectPair(botPairMenuData){
            this.$inertia.visit(`/hll/${botPairMenuData.pair_name}`)
        },
        changeAutoTuning(event){
            if(this.autoTuning === false){
                this.$confirm.require({
                    target: event.currentTarget,
                    message: 'ВНИМАНИЕ! При включении автонастройки будут изменены опасные настройки бота. Имеющиеся старые сделки могут быть проданы в сильный убыток. Рекомендуется включать этот режим на пустом боте. Продолжить ?',
                    header: 'Подтверждение',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        //console.log("accept");
                        this.$inertia.post('/bot/enable_autotuning', {
                            id: this.botResultData.userBotId
                        },{
                            preserveState: true,
                            onSuccess: (page) => {
                                this.refreshSettings();
                            },
                            onError: (errors) => {
                                this.$toast.add({severity:'error', summary: 'Error', detail: "Ошибка включения автоматической настройки", life: 5000});
                            }
                        });
                    },
                    reject: () => {
                        this.autoTuning = false;
                        //console.log("reject", this.autoTuning)
                    }
                });
            }else{
                this.$inertia.post('/bot/disable_autotuning', {
                    id: this.botResultData.userBotId
                },{
                    onSuccess: (page) => {
                        this.refreshSettings();
                    },
                    onError: (errors) => {
                        // console.log("error", errors);
                        this.$toast.add({severity:'error', summary: 'Error', detail: "Ошибка выключения автоматической настройки", life: 5000});
                    }
                });
            }
        },

    }
}
</script>

